export const articles = [
  {
    id: 1,
    title: '某顶流男星深夜私会女网红被拍，酒店共处三小时引热议',
    slug: 'dingliu-nanxing-sihui-wanghong',
    excerpt: '据知情人爆料，某当红男星近日被拍到深夜与一名女网红共同进入某五星级酒店，两人在房间内共处超过三小时。视频曝光后迅速登上热搜，引发粉丝和网友广泛讨论...',
    content: `据多位知情人联合爆料，某微博粉丝超过五千万的顶流男星近日被狗仔拍到深夜与一名女网红共同进入上海某五星级酒店。

据曝光的监控视频显示，当晚十一点左右，该男星乘坐一辆黑色商务车抵达酒店后门，随后一名戴着口罩和棒球帽的年轻女子紧随其后进入电梯。两人在酒店走廊有短暂交流，随后一同进入同一房间。

据酒店工作人员透露，两人在房间内停留时间超过三小时，直到凌晨两点半左右才先后离开。更劲爆的是，该女子并非首次与该男星同行，此前已被多次拍到出现在男星剧组附近。

消息曝光后，该男星工作室迅速发布声明称\"纯属不实消息\"，但并未提供任何有力证据反驳。而女方则在小号发布了一条意味深长的动态：\"有些人表面光鲜，背地里...\"引发网友更大猜测。

目前该事件仍在持续发酵中，男星超话已有大量粉丝宣布脱粉。更有前助理匿名爆料该男星\"私生活混乱\"、\"同时与多名女性保持暧昧关系\"，让事件进一步升温。`,
    categoryId: 1,
    categoryName: '明星塌房',
    author: '爆料小王子',
    publishDate: '2026-07-01',
    views: 89234,
    likes: 3456,
    comments: 892,
    isHot: true,
    isExclusive: true,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20corridor%20at%20night%20with%20dramatic%20warm%20red%20and%20amber%20lighting%2C%20mysterious%20silhouette%20figures%20in%20distance%2C%20celebrity%20scandal%20atmosphere%2C%20cinematic%20noir%20style%2C%20rich%20shadows%20and%20high%20contrast&width=800&height=500&seq=art-01&orientation=landscape',
    tags: ['顶流男星', '酒店约会', '女网红', '视频曝光'],
  },
  {
    id: 2,
    title: '千万粉丝女主播滤镜掉落，直播事故暴露真实容貌惊呆网友',
    slug: 'nvzhubo-lvjing-diaoluo',
    excerpt: '某平台坐拥千万粉丝的美妆女主播在一次直播连麦中意外关闭了美颜滤镜，真实容貌与直播间形象判若两人，引发网友热议和大量讨论...',
    content: `某直播平台坐拥千万粉丝的美妆主播\"甜甜酱\"在最近一次与其他主播连麦PK时，因系统故障意外关闭了美颜滤镜和瘦脸特效，其真实容貌瞬间暴露在全网上百万观众面前。

从曝光的画面可以看到，关掉滤镜后的\"甜甜酱\"与直播间中展示的形象判若两人。原本直播间中呈现的瓜子脸、大眼睛、瓷白肌肤，实际上脸型较圆、肤色暗沉、还有明显的痘痘和黑眼圈。

更劲爆的是，有技术大神通过视频逐帧分析发现，\"甜甜酱\"不仅使用了平台自带的美颜功能，还额外开启了第三方深度美颜软件，瘦脸程度开到最大，甚至使用了AI换脸级别的滤镜效果。

直播事故发生后，\"甜甜酱\"迅速下播并删除回放，但早有观众录屏保存。视频在全网疯传，相关话题阅读量迅速突破三亿。

大批粉丝表示\"被欺骗\"、\"人设崩塌\"，更有粉丝扒出该主播此前售卖的美妆产品声称\"用了就能像我一样\"，实为虚假宣传。目前已有消费者集体投诉该主播涉嫌虚假广告。`,
    categoryId: 2,
    categoryName: '网红反差',
    author: '键盘侦探',
    publishDate: '2026-06-30',
    views: 156789,
    likes: 5678,
    comments: 2341,
    isHot: true,
    isExclusive: false,
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20showing%20glamorous%20beauty%20livestream%20face%20versus%20natural%20real%20face%20without%20makeup%2C%20warm%20dramatic%20red%20and%20orange%20lighting%2C%20social%20media%20illusion%20shattered%20concept%2C%20cinematic%20artistic%20composition%2C%20high%20contrast&width=800&height=500&seq=art-02&orientation=landscape',
    tags: ['女主播', '美颜翻车', '滤镜破碎', '直播事故'],
  },
  {
    id: 3,
    title: '某知名导演被曝潜规则多名女演员，聊天记录不堪入目',
    slug: 'zhiming-daoyan-qian-guize',
    excerpt: '圈内知情人士曝光某著名导演长期潜规则多名女演员的惊人内幕，微信聊天记录完整流出，内容露骨不堪，涉及多位当红女星...',
    content: `今日，一则关于某知名导演的爆炸性内幕在圈内疯狂传播。据多位受害女演员联合爆料，该导演长期利用职权潜规则剧组女演员，手段令人发指。

曝光的微信聊天记录显示，该导演以\"试戏\"、\"指导表演\"为名，多次邀请女演员单独到酒店房间\"对戏\"。聊天中该导演言语露骨，多次发送暧昧信息和暴露照片。

更令人震惊的是，聊天记录中出现了多位当红女星的名字，其中两位一线女演员疑似已被\"潜规则\"成功。据知情人透露，该导演有一套完整的\"选妃流程\"：先以资源诱惑，再威逼利诱，最后拍摄视频威胁封口。

目前已有三名女演员站出来实名举报，称在该导演的多部戏中遭受不同程度的性骚扰。更有前剧组工作人员爆料，该导演的\"潜规则\"在圈内已是公开的秘密，很多女演员为了得到角色只能忍气吞声。

该导演工作室已发布律师函称\"纯属造谣\"，但随着越来越多的聊天记录和照片被放出，公众普遍倾向于相信受害者的说法。`,
    categoryId: 3,
    categoryName: '不雅内幕',
    author: '圈内老炮',
    publishDate: '2026-06-29',
    views: 234567,
    likes: 8901,
    comments: 4567,
    isHot: true,
    isExclusive: true,
    image: 'https://readdy.ai/api/search-image?query=Dark%20film%20director%20chair%20on%20empty%20movie%20set%20with%20dramatic%20warm%20red%20and%20orange%20spotlight%2C%20mysterious%20sinister%20atmosphere%2C%20power%20abuse%20concept%2C%20cinematic%20noir%20composition%2C%20rich%20shadows%20and%20tension&width=800&height=500&seq=art-03&orientation=landscape',
    tags: ['知名导演', '潜规则', '女演员', '聊天记录'],
  },
  {
    id: 4,
    title: '某男星妻子曝光劲爆聊天记录，婚内出轨多名女性实锤',
    slug: 'nanxing-hunnei-chugui-liaotian',
    excerpt: '某已婚男星妻子忍无可忍，在社交平台上公开曝光了丈夫与多名女性的暧昧聊天记录和转账记录，婚内出轨证据确凿...',
    content: `今日凌晨，某已婚男星的妻子突然在社交平台发布长文，怒斥丈夫长期婚内出轨，并附上了大量微信聊天记录和转账截图作为证据。

从曝光的聊天记录来看，该男星至少同时与四名女性保持着暧昧关系。聊天内容极其露骨，其中不乏大量约开房的对话和转账520、1314等示爱金额的记录。

更令网友愤怒的是，其中一名暧昧对象竟是男星粉丝后援会的副会长，年龄仅22岁。该粉丝还曾多次在公开场合表示\"哥哥是我永远的榜样\"，如今看来讽刺至极。

妻子在长文中透露，自己多次发现丈夫出轨证据，但为了孩子选择隐忍。然而丈夫不但不悔改，反而变本加厉，甚至将小三带回家中。直到昨天丈夫再次彻夜不归，妻子终于忍无可忍决定公之于众。

消息曝光后，该男星所有代言品牌迅速宣布解约。据不完全统计，仅一天时间该男星已损失超过八千万代言费。更有其主演的三部待播剧面临无法播出的风险，投资方已准备起诉索赔。`,
    categoryId: 4,
    categoryName: '劲爆聊天',
    author: '情感观察员',
    publishDate: '2026-06-28',
    views: 345678,
    likes: 12345,
    comments: 6789,
    isHot: true,
    isExclusive: false,
    image: 'https://readdy.ai/api/search-image?query=Broken%20wedding%20ring%20on%20cracked%20surface%20with%20scattered%20chat%20message%20bubbles%20around%20it%2C%20warm%20dramatic%20red%20and%20orange%20lighting%2C%20marriage%20betrayal%20concept%2C%20cinematic%20emotional%20composition%2C%20high%20contrast%20shadows&width=800&height=500&seq=art-04&orientation=landscape',
    tags: ['婚内出轨', '聊天记录', '妻子爆料', '品牌解约'],
  },
  {
    id: 5,
    title: '独家：某选秀节目黑幕曝光，出道位早已内定',
    slug: 'xuansiu-heimu-neiding-chudao',
    excerpt: '本网站独家获取某热门选秀节目内部文件，出道位早在节目开播前就已内定，粉丝投票只是走过场， millions of dollars behind the scenes...',
    content: `本网站独家获得某热门选秀节目的内部文件和录音，揭开了综艺节目背后令人震惊的黑幕。

据获得的内部策划文档显示，该节目的最终出道位在节目正式录制前三个月就已经全部确定。五位\"出道\"选手均来自特定的几家经纪公司，而这些公司与节目制作方有着深度的资本合作关系。

更惊人的是，粉丝花费数百万元打投的投票环节完全是摆设。内部录音中，节目总监明确表示：\"票数随便做做样子就行，最后出道名单按合同走。\"

曝光的财务往来记录显示，五家经纪公司共向节目制作方支付了超过三亿元的\"合作费用\"，而作为交换，每家保证至少一个出道位。这意味着粉丝真金白银的投票，从一开始就毫无意义。

目前已有参与该节目的练习生匿名发声，称自己虽然粉丝投票数一直名列前茅，但早就知道自己\"不可能出道\"，因为\"没有签那个合同\"。

本网站已将全部证据材料提交相关部门，事件正在进一步调查中。`,
    categoryId: 5,
    categoryName: '独家爆料',
    author: '深度调查组',
    publishDate: '2026-06-27',
    views: 456789,
    likes: 15678,
    comments: 8901,
    isHot: true,
    isExclusive: true,
    image: 'https://readdy.ai/api/search-image?query=Television%20talent%20show%20stage%20with%20spotlights%20revealing%20hidden%20puppet%20strings%20controlling%20performer%20silhouettes%2C%20warm%20dramatic%20red%20and%20orange%20theater%20lighting%2C%20show%20business%20corruption%20concept%2C%20cinematic%20dramatic%20composition%2C%20rich%20shadows&width=800&height=500&seq=art-05&orientation=landscape',
    tags: ['选秀黑幕', '独家爆料', '出道位内定', '粉丝打投'],
  },
  {
    id: 6,
    title: '某女星直播带货翻车，虚假宣传被央视点名批评',
    slug: 'nvxing-zhibo-fanche-xujia-xuanchuan',
    excerpt: '某当红女星在直播间推销的\"美白神器\"被检测出含有违禁成分，其夸大功效的宣传话术被央视曝光，引发消费者大规模维权...',
    content: `央视《每周质量报告》今日曝光了一起明星直播带货虚假宣传案例，某当红女星在直播间推销的\"美白神器\"被检出含有国家明令禁止的汞超标成分。

据悉，该女星在直播中声称该产品\"用一次白一度\"、\"七天见效\"、\"医生都在推荐\"，并现场展示使用前后的对比效果。然而消费者购买使用后，不但没有出现宣传效果，反而出现皮肤过敏、红肿等症状。

检测机构报告显示，该产品汞含量超出国家标准近200倍，长期使用将对人体肾脏和神经系统造成严重损害。而该女星在直播中声称的\"天然成分\"、\"无副作用\"纯属虚假宣传。

央视记者调查发现，该产品的所谓\"使用前后对比\"实为后期P图，所谓的\"医生推荐\"也是伪造的。该产品实际成本不到十元，直播间售价却高达299元。

目前已有超过两千名消费者联合发起维权诉讼，要求该女星和商家退一赔三。而该女星的社交媒体账号自曝光后已停更三天，多个代言品牌已悄悄删除合作内容。`,
    categoryId: 1,
    categoryName: '明星塌房',
    author: '消费者卫士',
    publishDate: '2026-06-26',
    views: 567890,
    likes: 23456,
    comments: 11234,
    isHot: true,
    isExclusive: false,
    image: 'https://readdy.ai/api/search-image?query=Livestream%20shopping%20setup%20with%20beauty%20products%20and%20broken%20promises%20sign%2C%20dramatic%20warm%20red%20and%20orange%20warning%20lights%2C%20consumer%20deception%20concept%2C%20cinematic%20commercial%20critique%20composition%2C%20high%20contrast%20and%20tension&width=800&height=500&seq=art-06&orientation=landscape',
    tags: ['直播带货', '虚假宣传', '央视曝光', '消费者维权'],
  },
  {
    id: 7,
    title: '某男团成员夜店狂欢视频流出，与多名女子举止亲密',
    slug: 'nan-tuan-yedian-kuanghuan-shipin',
    excerpt: '某当红男团成员被拍到在高端夜店与多名女子狂欢至凌晨，视频中的亲密互动与偶像人设形成强烈反差...',
    content: `某人气男团成员近日被拍到在某高端夜店与多名女子狂欢至凌晨四点，相关视频在网络疯传，与其在粉丝面前塑造的\"纯情少年\"人设形成强烈反差。

视频显示，该成员在夜店卡座与至少三名女子饮酒作乐，期间多次与其中一名长发女子亲密拥抱，甚至当众接吻。据现场目击者称，该成员当晚消费超过十万元，全程有保镖在旁保护防止拍照。

更劲爆的是，视频中的长发女子被扒出是该成员此前否认恋情的\"普通朋友\"，两人的亲密举动显然超出了普通朋友的范畴。

该男团一直以\"正能量偶像\"、\"清纯男孩\"形象示人，队长更是多次在综艺节目中表示\"我们团规就是不允许恋爱\"。此次事件曝光后，团粉和CP粉集体崩溃，大量粉丝在超话中表达失望。

该成员经纪公司紧急发布声明称\"只是普通朋友聚会\"、\"拥抱只是礼仪\"。但网友并不买账，纷纷留言：\"谁家礼仪需要嘴对嘴？\"`,
    categoryId: 2,
    categoryName: '网红反差',
    author: '夜店眼线',
    publishDate: '2026-06-25',
    views: 678901,
    likes: 28901,
    comments: 14567,
    isHot: false,
    isExclusive: false,
    image: 'https://readdy.ai/api/search-image?query=Nightclub%20VIP%20section%20with%20silhouettes%20of%20people%20partying%20under%20dramatic%20warm%20red%20and%20orange%20neon%20lights%2C%20celebrity%20scandal%20atmosphere%2C%20exclusive%20party%20exposure%20concept%2C%20cinematic%20noir%20style%2C%20rich%20shadows%20and%20mystery&width=800&height=500&seq=art-07&orientation=landscape',
    tags: ['男团成员', '夜店狂欢', '人设崩塌', '亲密视频'],
  },
  {
    id: 8,
    title: '某上市企业高管不雅视频遭勒索，背后产业链触目惊心',
    slug: 'qiye-gaoguan-buya-shipin-qiaozha',
    excerpt: '某上市公司高管被曝遭遇不雅视频勒索，警方介入调查后牵出一条涉及数百人的非法偷拍产业链，触目惊心...',
    content: `某上市公司高管近日向警方报案，称自己遭遇不雅视频勒索，对方威胁若不支付五百万元就将视频公开。警方介入调查后，竟牵出了一条令人触目惊心的非法偷拍产业链。

据警方通报，该高管在一次商务应酬中被人在酒中下药，随后被带至酒店房间拍摄了不雅视频。而该犯罪团伙并非随机作案，而是专门 targeting 有钱有地位的企业高管和公众人物。

更令人震惊的是，该团伙拥有一个超过两百人的\"素材库\"，其中包括多名企业高管、知名律师、医生甚至政府官员的不雅视频。他们根据受害者的社会地位和经济能力\"定价\"，勒索金额从几十万到上千万不等。

警方在犯罪团伙的窝点搜出了大量偷拍设备和存储设备，其中视频文件超过5TB，涉及受害者三百余人。该团伙还雇佣了专门的\"猎手\"，潜伏在各大高端会所和商务场合寻找目标。

目前该团伙主要成员已全部落网，案件正在进一步侦办中。警方提醒公众，特别是商务人士，在外应酬务必提高警惕，离开视线的饮品不要再饮用。`,
    categoryId: 3,
    categoryName: '不雅内幕',
    author: '法制前线',
    publishDate: '2026-06-24',
    views: 789012,
    likes: 34567,
    comments: 18901,
    isHot: false,
    isExclusive: true,
    image: 'https://readdy.ai/api/search-image?query=Hidden%20spy%20camera%20on%20hotel%20room%20wall%20with%20dramatic%20warm%20red%20and%20orange%20warning%20lights%2C%20privacy%20violation%20and%20blackmail%20concept%2C%20cinematic%20thriller%20atmosphere%2C%20dark%20moody%20composition%2C%20rich%20shadows%20and%20tension&width=800&height=500&seq=art-08&orientation=landscape',
    tags: ['不雅视频', '勒索敲诈', '偷拍产业链', '企业高管'],
  },
];

export const trendingArticles = [
  {
    id: 9,
    title: '某知名男星税务问题被调查，多个项目紧急叫停',
    slug: 'zhiming-nanxing-shuiwu-diaocha',
    excerpt: '税务部门进驻某男星工作室展开调查，其参与的多部影视作品已紧急暂停拍摄...',
    categoryName: '明星塌房',
    views: 456782,
    publishDate: '2026-07-01',
    image: 'https://readdy.ai/api/search-image?query=Government%20audit%20investigation%20room%20with%20stacks%20of%20financial%20documents%20under%20dramatic%20warm%20red%20and%20orange%20desk%20lamp%20light%2C%20tax%20evasion%20investigation%20concept%2C%20cinematic%20noir%20atmosphere%2C%20rich%20shadows%20and%20tension&width=400&height=300&seq=art-09&orientation=landscape',
  },
  {
    id: 10,
    title: '百万粉健身博主被曝使用违禁药物，身材全是假的',
    slug: 'jianshen-bozhu-weijin-yaowu',
    excerpt: '某健身博主被检测出长期使用类固醇，其引以为傲的肌肉身材全靠药物支撑...',
    categoryName: '网红反差',
    views: 389451,
    publishDate: '2026-06-30',
    image: 'https://readdy.ai/api/search-image?query=Gym%20dumbbells%20with%20pill%20bottles%20and%20syringes%20in%20background%2C%20dramatic%20warm%20red%20and%20orange%20warning%20lighting%2C%20performance%20enhancing%20drugs%20concept%2C%20fitness%20deception%2C%20cinematic%20dramatic%20composition%2C%20high%20contrast&width=400&height=300&seq=art-10&orientation=landscape',
  },
  {
    id: 11,
    title: '某歌手被曝抄袭国外作品，连歌词都是直接翻译的',
    slug: 'geshou-chaoxi-guowai-zuopin',
    excerpt: '某当红歌手的新歌被指抄袭国外小众歌手作品，旋律重合度超过80%...',
    categoryName: '吃瓜大全',
    views: 321098,
    publishDate: '2026-06-29',
    image: 'https://readdy.ai/api/search-image?query=Two%20overlapping%20music%20sheets%20with%20similar%20notes%20highlighted%20in%20dramatic%20warm%20red%20and%20orange%20spotlight%2C%20plagiarism%20and%20copyright%20theft%20concept%2C%20cinematic%20artistic%20composition%2C%20rich%20shadows%20and%20contrast&width=400&height=300&seq=art-11&orientation=landscape',
  },
  {
    id: 12,
    title: '某女主播被榜一大哥曝光私密视频，聊天记录尺度惊人',
    slug: 'nvzhubo-simi-shipin-bangyi',
    excerpt: '某女主播的榜一大哥因爱生恨，曝光了两人交往期间的大量私密视频和露骨聊天记录...',
    categoryName: '劲爆聊天',
    views: 298765,
    publishDate: '2026-06-28',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20leaked%20intimate%20messages%20with%20dramatic%20warm%20red%20and%20orange%20glow%2C%20broken%20heart%20and%20betrayal%20concept%2C%20cinematic%20emotional%20composition%2C%20rich%20shadows%20and%20high%20contrast&width=400&height=300&seq=art-12&orientation=landscape',
  },
  {
    id: 13,
    title: '某综艺常驻嘉宾被曝学历造假，博士论文查重率80%',
    slug: 'zongyi-changzhu-xueli-zaojia',
    excerpt: '某综艺节目的\"学霸人设\"嘉宾被扒出学历造假，其博士论文查重率高达80%...',
    categoryName: '吃瓜大全',
    views: 267890,
    publishDate: '2026-06-27',
    image: 'https://readdy.ai/api/search-image?query=Forged%20diploma%20certificate%20with%20red%20fake%20stamp%20on%20dark%20desk%20under%20dramatic%20warm%20red%20and%20orange%20desk%20lamp%20light%2C%20academic%20fraud%20concept%2C%20cinematic%20noir%20atmosphere%2C%20rich%20shadows%20and%20tension&width=400&height=300&seq=art-13&orientation=landscape',
  },
  {
    id: 14,
    title: '某男星前女友发万字长文控诉，曝其特殊癖好',
    slug: 'nanxing-qian-nvyou-kongsu-pihao',
    excerpt: '某男星前女友发布万字长文，详细揭露两人交往期间的各种惊人内幕和男方特殊癖好...',
    categoryName: '不雅内幕',
    views: 245678,
    publishDate: '2026-06-26',
    image: 'https://readdy.ai/api/search-image?query=Long%20handwritten%20letter%20on%20aged%20paper%20with%20tears%20and%20dramatic%20warm%20red%20and%20orange%20candlelight%2C%20emotional%20confession%20and%20betrayal%20concept%2C%20cinematic%20dramatic%20composition%2C%20rich%20shadows%20and%20high%20contrast&width=400&height=300&seq=art-14&orientation=landscape',
  },
];